/**
 * @typedef {import('shared/MarketplaceServiceActivityProxy/Dependencies').default} Dependencies
 * @typedef {import('shared/MarketplaceService/GetsSuggestedVendorCategories').default} GetsSuggestedVendorCategories
 * @typedef {import('shared/MarketplaceService/GetsVendors').default} GetsVendors
 * @typedef {import('shared/MarketplaceService/Vendor').default} Vendor
 */
/**
 * @implements {GetsSuggestedVendorCategories}
 * @implements {GetsVendors}
 */
export default class MarketplaceServiceActivityProxy {
	/** @param {Dependencies} dependencies */
	constructor(dependencies) {
		this.activityService = dependencies.activityService;
		this.marketplaceService = dependencies.marketplaceService;
	}

	/**
	 * @param {string} query
	 * @returns {Promise<string[]>}
	 */
	async getSuggestedVendorCategories(query) {
		return this.marketplaceService.getSuggestedVendorCategories(query);
	}

	/**
	 * @param {string} query
	 * @param {string} postalCode
	 * @param {number} [page]
	 * @param {string} [slug]
	 * @param {{limit?: number, relatedType?: 'tenant' | 'local'}} [options]
	 * @returns {Promise<Readonly<{ categories: string[], pages: number, restricted: boolean, vendors: Vendor[] }>>}
	 */
	async getVendors(query, postalCode, page, slug, options) {
		if (this.activityService.identifiesKeywords(query)) {
			this.activityService.logActivity(
				query,
				'marketplace_search_keywords_highpoint'
			);
		}

		return this.marketplaceService.getVendors(
			query,
			postalCode,
			page,
			slug,
			options
		);
	}
}
